export const POST_NEW_TRIAL_USER = "/demo/register";
// Get new trial user information. (Name, email, etc)
export const GET_NEW_TRIAL_USER = "/demo/register";
// Update a specific prospective sell.
export const UPDATE_NEW_TRIAL_USER = "/demo/register";
//Delete Data
export const DELETE_NEW_TRIAL_USER = "/demo/register";
// Send a trial email for self registration.
export const SEND_NEW_TRIAL_USER_EMAIL = "/internal/createtriallink";
//Login
export const POST_LOGIN = "/login";
export const POST_VERIFY_TOTP = "/verifyTotp";

export const ADD_COGNITO_USER = "/signup";

export const POST_FORGET_PASSWORD = "/forgotpassword";

export const POST_RESET_FORGOT_PASSWORD = "/confirmforgotpassword";

export const GET_NEW_COGNITO_USER = "/user";

export const COGNITO_USER = "/user";

export const ORGANIZATION = "/organizations";

export const ORGANIZATION_PRE_ON_BOARDED = "/organization/getPreOnboardOrgList";

export const ORGANIZATION_PRE_ON_BOARDED_ACTIVATION_LINK = "/organization/resendOrgOnboardActivationLink";

export const ORGANIZATION_TRIAL_ACCOUNT_USER = "/organization/trial";

export const ORGANIZATION_ACCOUNT = "/accounts";

export const ORGANIZATION_ACCOUNT_WORKLOADS = "/accounts/workloads";

export const SCAN_SCHEDULES = "/cloudnova/audit/scan/scanSchedules";
export const SCAN_SCHEDULES_FREQUENCY = "/cloudnova/audit/scan/scanSchedules";

export const FEATURE_CONFIGURATION = "/accounts/feature-configuration";

export const ORGANIZATION_USER = "/accounts/users";

export const ORGANIZATION_BILLING = "/billing";

export const ORGANIZATION_BILLING_USAGE = "/billing/usage";

//GLOBAL LICENSE 
export const GLOBAL_LICENSE = '/license';
export const ADD_COMPLIANCE_ADDONS = "/license/custom";

export const CUSTOM_LICENSE = "/license/custom";

// GLOBAL IAAC
export const GLOBAL_IAAC = "/iacmanagementfromui/global";

export const ORGANIZATION_IAAC = "/iacmanagementfromui/license";
export const ORGANIZATION_IAAC_LICENSES = "/cloudnova/iaacLicenseMgr";
export const ORGANIZATION_IAAC_SUBSCRIPTION = "/cloudnova/iaacSubscription";
// Malware Scan, logs
export const MALWARE_SCAN_LOGS = "/malwarelogs"

// Extend Trial
export const EXTEND_TRIAL = "/organizations/extendTrial";